import React, { useEffect } from "react";
import { useVeltClient } from "../context";
export function useContactUtils() {
    var _a = React.useState(), contactElement = _a[0], setContactElement = _a[1];
    var client = useVeltClient().client;
    React.useEffect(function () {
        if (!client || contactElement)
            return;
        var loadedContactElement = client.getContactElement();
        setContactElement(loadedContactElement);
    }, [client, setContactElement, contactElement]);
    return contactElement;
}
export function useContactSelected() {
    var contactElement = useContactUtils();
    var _a = React.useState(), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!contactElement)
            return;
        var subscription = contactElement.onContactSelected().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [contactElement === null || contactElement === void 0 ? void 0 : contactElement.onContactSelected]);
    return data;
}
export function useContactList() {
    var contactElement = useContactUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    var subscriptionRef = React.useRef();
    useEffect(function () {
        if (!contactElement)
            return;
        // Unsubscribe from the previous subscription if it exists
        if (subscriptionRef.current) {
            subscriptionRef.current.unsubscribe();
        }
        var subscription = contactElement.getContactList().subscribe(function (res) {
            setData(res);
        });
        // Store the new subscription
        subscriptionRef.current = subscription;
        // Cleanup function
        return function () {
            if (subscriptionRef.current) {
                subscriptionRef.current.unsubscribe();
            }
        };
    }, [contactElement === null || contactElement === void 0 ? void 0 : contactElement.getContactList]);
    return data;
}
